import { read_u32, Sink } from "../../helpers/serializerHelpers";

export class TlvHeader {
    public objectType: number = 0;
    public dataLength: number = 0; //Object length in bytes including TLV header according to documentation, however in practice this does not include size of header.

    public deserialize(bytes: Sink) {
        if (bytes.view.byteLength - bytes.pos < this.getLength()) { return this }
        this.objectType = read_u32(bytes);
        this.dataLength = read_u32(bytes);
        return this;
    }

    public getLength() {
        return 8;
    }
}

